<template>
    <div> 
        <!-- Corps -------------------------------------------------------------------------------->          
        <CheckupTab v-bind="{column:column, parameters:parameters, textSign:textSign}"/>
    </div>
</template>

<script>

import CheckupTab from '@/components/checkup.detail.tab.component.vue';

export default {
  name: 'CheckupPart4',
  props: ['column','textSign'],
  components: {
      CheckupTab
  },
  data() {
    return {
        parameters:{
            withTitle: false,
            classColor: "colorS",
            borderLeft : "",
            borderRight : ""
        },
    };
  }
};
</script>

<style scoped>

</style>